import { c as _c } from "react/compiler-runtime";
import GridRow from "@/components/common/grid-row/grid-row";
import css from "./home-points.module.scss";
import GridColumn from "@/components/common/grid-column/grid-column";
import Link, { LinkType } from "@/components/common/link/link";
import { ProofStats } from "@/sanity/sanity.types";
import CheckmarkIcon from "@/components/common/checkmark-icon/checkmark-icon";
import { highlightText } from "@/utilities/highlightText";
import AnimatedMobileShowcase from "@/components/animatedMobileShowcase/animatedMobileShowcase";
import imageUrl from "@/sanity/utilities/imageUrl";
interface SanityImage {
  _type: "image";
  asset?: {
    _ref: string;
    _type: "reference";
    _weak?: boolean;
  };
  hotspot?: any;
  crop?: any;
}
interface IHomePointsProps {
  data: ProofStats;
  homeAnimatedMobileBackground?: SanityImage;
  homeAnimatedMobile1?: SanityImage;
  homeAnimatedMobile2?: SanityImage;
}
const highlights: string[] = ["save $1,200 a month", "95% of clients", "Over $34 million"];
const HomePoints = props => {
  const $ = _c(23);
  const {
    data,
    homeAnimatedMobileBackground,
    homeAnimatedMobile1,
    homeAnimatedMobile2
  } = props;
  const {
    cta,
    items,
    supportingBullets
  } = data;
  let t0;
  if ($[0] !== homeAnimatedMobileBackground) {
    t0 = homeAnimatedMobileBackground ? imageUrl(homeAnimatedMobileBackground).url() : "/mobile-background-image.png";
    $[0] = homeAnimatedMobileBackground;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== homeAnimatedMobile1) {
    t1 = homeAnimatedMobile1 ? imageUrl(homeAnimatedMobile1).url() : "/mobile-screen-1.png";
    $[2] = homeAnimatedMobile1;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== homeAnimatedMobile2) {
    t2 = homeAnimatedMobile2 ? imageUrl(homeAnimatedMobile2).url() : "/mobile-screen-2.png";
    $[4] = homeAnimatedMobile2;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t0 || $[7] !== t1 || $[8] !== t2) {
    t3 = <GridColumn lg={6}><div className="mb-20 mt-20 md:mt-32 md:mb-32 lg:mb-0 lg:mt-40"><AnimatedMobileShowcase backgroundSrc={t0} leftMobileSrc={t1} rightMobileSrc={t2} className="mt-10 h-[550px]" /></div></GridColumn>;
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== items) {
    t4 = !!items?.length && <h2 className="mb-6 text-center lg:text-left">{items[0].label}</h2>;
    $[10] = items;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== supportingBullets) {
    t5 = !!supportingBullets?.length && <ul className={css.homePointsList}>{supportingBullets.map(_temp)}</ul>;
    $[12] = supportingBullets;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== cta) {
    t6 = cta?.link && <Link className={`${css.homePointsButton} !w-full md:!w-[50%]`} href={cta.link.href ?? ""} linkType={LinkType.BUTTON} data-cta-id={cta.link?.ctaId ?? ""} data-cta-value={cta.link?.ctaValue ?? ""} rel={cta?.link?.nofollow}>{cta.link.label}</Link>;
    $[14] = cta;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t4 || $[17] !== t5 || $[18] !== t6) {
    t7 = <GridColumn lg={6}><div className="mt-[10px] flex h-full flex-col justify-center md:mt-0">{t4}{t5}{t6}</div></GridColumn>;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t3 || $[21] !== t7) {
    t8 = <GridRow>{t3}{t7}</GridRow>;
    $[20] = t3;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
};
export default HomePoints;
function _temp(bullet, index) {
  const highlight = highlights[index];
  return <li key={index} className={css.homePointsListItem}><CheckmarkIcon className="mr-3" /><span className="text-xl">{highlightText(bullet, highlight)}</span></li>;
}